import React from "react";

export default function GoogleGIcon({ className }) {
  return (
    <>
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.64 9.20811C17.64 8.56992 17.5828 7.95628 17.4764 7.36719H9V10.8486H13.8437C13.635 11.9736 13.0009 12.9268 12.0477 13.5649V15.8231H14.9564C16.6582 14.2563 17.64 11.949 17.64 9.20811Z"
          fill="#4285F4"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.99981 18.001C11.4298 18.001 13.4671 17.1951 14.9562 15.8205L12.0476 13.5623C11.2416 14.1023 10.2107 14.4214 8.99981 14.4214C6.6557 14.4214 4.6716 12.8382 3.96387 10.7109H0.957031V13.0428C2.43795 15.9841 5.4816 18.001 8.99981 18.001Z"
          fill="#34A853"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.96411 10.7128C3.78411 10.1728 3.68184 9.59596 3.68184 9.00278C3.68184 8.40959 3.78411 7.83277 3.96411 7.29277V4.96094H0.957278C0.347729 6.17594 0 7.5505 0 9.00278C0 10.4551 0.347729 11.8296 0.957278 13.0446L3.96411 10.7128Z"
          fill="#FBBC05"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.99981 3.57957C10.3212 3.57957 11.5075 4.03366 12.4403 4.92548L15.0217 2.3441C13.463 0.891823 11.4257 0 8.99981 0C5.4816 0 2.43795 2.01683 0.957031 4.95821L3.96387 7.29004C4.6716 5.16276 6.6557 3.57957 8.99981 3.57957Z"
          fill="#EA4335"
        />
      </svg>
    </>
  );
}
